export default __webpack_public_path__ + "static/media/015.ee757965.jpg";